import React from 'react';
import {
  Description,
  ServiceContainer,
  ServiceEyebrow,
  ServiceFooter,
  ServiceIcon,
  ServiceStack,
  Title
} from '../../Styled/playgraund/playground.style';

const CardService = ({ title, description, images, eyebrow, stack, animation = 'fade-up' }) => {
  return (
    <ServiceContainer data-aos={animation}>
      {eyebrow && <ServiceEyebrow>{eyebrow}</ServiceEyebrow>}
      <ServiceIcon>
        {images}
      </ServiceIcon>
      <Title>{title}</Title>
      <Description>{description}</Description>
      {stack && (
        <ServiceFooter>
          <ServiceStack>{stack}</ServiceStack>
        </ServiceFooter>
      )}
    </ServiceContainer>
  );
};

export default CardService;